import {MonoTypeOperatorFunction, pipe} from 'rxjs';
import {map} from 'rxjs/operators';
import {UtilsService} from '../services';
import {RecordClassifica, Torneo, Utente} from '../../core/@types';

export const normalizeUtente = (): MonoTypeOperatorFunction<Utente> => pipe(
  map((utente) => UtilsService.normalizeUtente(utente))
);

export const normalizeTorneo = (): MonoTypeOperatorFunction<Torneo> => pipe(
  map((torneo) => UtilsService.normalizeTorneo(torneo))
);

export const normalizeTorneoConClassifica = (): MonoTypeOperatorFunction<{
  torneo: Torneo;
  classifica: RecordClassifica[]
}> => pipe(
  map(({classifica, torneo}) => ({
    classifica,
    torneo: UtilsService.normalizeTorneo(torneo)
  }))
);

